import { BorderTable } from '@af/design-system-docs-ui';
import { Stack, Text } from '@atlaskit/primitives';
import * as React from 'react';
export default {
  BorderTable,
  Stack,
  Text,
  React
};